export default __webpack_public_path__ + "static/media/bat4.463761de.jpg";